export function hasNumber(value) {
    return /\d/.test(value);
}